<script lang="ts">
	import { Device } from "luxedo-data"
	import DeviceFilter from "../../../reusable/device-filter/DeviceFilter.svelte"
	import { ShowLibraryController } from "../ShowLibraryController"
	import { fade } from "svelte/transition"
	import { QuickSelectPointer } from "misc-ui"

	interface Props {
		isOpen: boolean
		onToggle: (doOpen?: boolean) => void
	}

	let { isOpen, onToggle }: Props = $props()
	let anchorElem: HTMLDivElement = $state()

	let selectedDevice: Device = $state(undefined)
	ShowLibraryController.subscribe((ctx) => {
		selectedDevice = ctx.deviceFilter
	})

	function handleTouchStart(e: TouchEvent) {
		const { clientX, clientY } = e.touches[0]
		const elems = document.elementsFromPoint(clientX, clientY)
		if (!elems.includes(anchorElem)) onToggle(false)
	}
</script>

<div class="mobile-device-filter-anchor">
	{#if isOpen}
		<div
			class="mobile-device-filter"
			bind:this={anchorElem}
			in:fade={{ duration: 150 }}
			out:fade={{ duration: 150 }}
		>
			<QuickSelectPointer />
			<DeviceFilter
				onSetDeviceFilter={ShowLibraryController.setDeviceFilter}
				{selectedDevice}
				heading={""}
			/>
		</div>
	{/if}
</div>

<svelte:window ontouchstart={handleTouchStart} />

<style>
	.mobile-device-filter-anchor {
		position: fixed;
		right: 0.5rem;
	}

	.mobile-device-filter {
		background-color: var(--color-bg-opaque);
		border: 1px solid var(--color-border);
		padding: 0.25rem;
		margin-top: 1rem;
		padding-bottom: 0;
		max-height: 50vh;
		overflow: hidden;
		border-radius: var(--br);
		display: flex;
	}

	.mobile-device-filter-anchor :global(.setting-buttons) {
		display: none;
	}

	.mobile-device-filter :global(.device-filter-container) {
		max-width: 90vw;
		width: 12rem;
		min-width: 50vw;
		height: unset;
	}

	.mobile-device-filter :global(.quick-select-pointer) {
		rotate: 90deg;
		position: absolute;
		top: 0.4rem;
		right: 4rem;
	}

	.mobile-device-filter :global(.projector-filter-instance) {
		background-color: var(--color-bg-dark);
	}
</style>
